import React from "react";
import ReactDOM from "react-dom/client";
import { FluentProvider, webLightTheme, webDarkTheme, teamsHighContrastTheme } from "@fluentui/react-components";
import { app } from "@microsoft/teams-js";
import App from "./App";

const themeMap: Record<string, typeof webLightTheme> = {
  dark: webDarkTheme,
  contrast: teamsHighContrastTheme,
  default: webLightTheme,
};

async function bootstrap() {
  let theme = webLightTheme;

  try {
    await app.initialize();
    const context = await app.getContext();
    theme = themeMap[context.app.theme] ?? webLightTheme;

    // Re-apply theme when Teams theme changes
    app.registerOnThemeChangeHandler((t) => {
      document.documentElement.setAttribute("data-theme", t);
    });
  } catch {
    // Running outside Teams (local dev) — use default theme
  }

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <FluentProvider theme={theme} style={{ height: "100vh" }}>
        <App />
      </FluentProvider>
    </React.StrictMode>
  );
}

bootstrap();
